// eslint-disable-next-line import/no-internal-modules
import { WidgetContainerConfig } from '@insided/deprecated-preact-components/widget-container'
import { Component } from 'preact'
import Field from './FieldContainer'
import { AbstractFieldProps } from './types'

type BackgroundDisplayValue = WidgetContainerConfig['backgroundColorDisplay']

export interface BackgroundDisplayFieldProps extends AbstractFieldProps<BackgroundDisplayValue> {}

interface FieldState {
  value: BackgroundDisplayValue
}

interface Option {
  value: BackgroundDisplayValue
  label: string
}

export const BACKGROUND_DISPLAY_OPTIONS: Option[] = [
  {
    value: 'none',
    label: 'None'
  },
  {
    value: 'solid_color',
    label: 'Custom solid color'
  }
]

const INPUT_ID = 'widget-background-selector'
export class BackgroundDisplayField extends Component<BackgroundDisplayFieldProps, FieldState> {
  state = {
    value: this.props.value ?? 'none'
  }

  render() {
    return (
      <Field inputId={INPUT_ID} title='Background mode'>
        <select
          id={INPUT_ID}
          name={INPUT_ID}
          onChange={(event) => {
            const value = (event.target as HTMLSelectElement).value as BackgroundDisplayValue
            this.setState({ value }, () => this.props.onValueChange(value))
          }}
        >
          {BACKGROUND_DISPLAY_OPTIONS.map(({ value, label }) => (
            <option key={value} value={value} selected={this.state.value === value}>
              {label}
            </option>
          ))}
        </select>
      </Field>
    )
  }
}

export default BackgroundDisplayField
